import { HttpStatusError } from '../../interfaces/api/http-status-error.interface';

export const isHttpStatusError = (error: unknown): error is HttpStatusError =>
  error instanceof Error &&
  typeof (error as Partial<HttpStatusError>).status === 'number';
